import {api} from '../../../helpers';

export function fetchApiLogs(params) {
  return api.get('/logs/services', {params}).then(res => res.data);
}
export function exportApiLogs(params) {
  return api.get('/logs/v3/services/export', {params}).then(res => res.data);
}
